/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_DivisionsInputs */

const en_mk_mx_divisions = /** @type {(inputs: Mk_Mx_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisions`)
};

const id_mk_mx_divisions = /** @type {(inputs: Mk_Mx_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi`)
};

/**
* | output |
* | --- |
* | "Divisions" |
*
* @param {Mk_Mx_DivisionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_divisions = /** @type {((inputs?: Mk_Mx_DivisionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_DivisionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_divisions(inputs)
	return en_mk_mx_divisions(inputs)
});